import { get } from "@ember/object";
import type { ValidationFunction } from "core/validators";
import type { EmberChangeset } from "ember-changeset";

// This validator is from https://github.com/skaterdav85/ember-changeset-conditional-validations/

export default function validateSometimes(
  validators,
  condition,
  changeset?: EmberChangeset
) {
  if (Array.isArray(validators)) {
    return validators.map(validator =>
      guardValidatorWithCondition(validator, changeset)
    );
    // eslint-disable-next-line no-else-return
  } else {
    return guardValidatorWithCondition(validators, changeset);
  }

  function guardValidatorWithCondition(
    validator: ValidationFunction,
    changeset?: EmberChangeset
  ) {
    return function (key, newValue, oldValue, changes, content) {
      let thisValue;
      if (changeset) {
        thisValue = changeset;
      } else {
        thisValue = {
          get(property) {
            return get(changes, property) != null
              ? get(changes, property)
              : get(content, property);
          }
        };
      }

      if (condition.call(thisValue, changes, content)) {
        return validator(key, newValue, oldValue, changes, content);
      }
      return true;
    };
  }
}
